import { TableCell, withStyles } from '@material-ui/core';

const TableCellWithoutBorder = withStyles({
  root: {
    borderBottom: 'none',
  },
})(TableCell);

export default TableCellWithoutBorder;
